import { createContext, useContext } from "react";
import { siteConfig as defaults } from "@/data/siteConfig";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  return (
    <ContentContext.Provider value={{ contact: defaults.contact, categories: defaults.categories, faqs: defaults.faqs }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useSiteContent = () => useContext(ContentContext);
